// extracted by mini-css-extract-plugin
module.exports = {"light":"app_light__i0p1S","dark":"app_dark__1r5C2","app":"app_app__2rcgH"};